import { render, staticRenderFns } from "./plattransactiondetais-add-or-update.vue?vue&type=template&id=48bda85e&"
import script from "./plattransactiondetais-add-or-update.vue?vue&type=script&lang=js&"
export * from "./plattransactiondetais-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports